export const part1 = [
  {
    name: "Live",
    nav: "/live",
  },
  {
    name: "Push",
    nav: "/push",
  },
  {
    name: "Note",
    nav: "/note",
  },
  {
    name: "Link",
    nav: "/link",
  },
  {
    name: "Shop",
    nav: "/shop",
  },
  {
    name: "Packs",
    nav: "/packs",
  },
  {
    name: "Help",
    nav: "/help",
  },
];
export const part2 = [
  "Blog",
  "Ableton for the Classroom",
  "Ableton for Colleges and Universities",
  "Certified Training",
  "About Ableton",
  "Jobs",
  "Apprenticeships",
];
export const part3 = [
  {
    name: "Loop",
    value:
      "Watch Talks, Performances and Feature from Ableton's Summit for Music Makers",
  },
  {
    name: "Learning Music",
    value: "Learn the fundamentals of music making right in your browser.",
  },
  {
    name: "Learning Synths",
    value:
      "Get started with synthesis using a web-based synth and accompanying lessons.",
  },
  {
    name: "Making Music",
    value: "WSome tips from 74 creative Strategies for Electronic Producers.",
  },
];
